import { render, staticRenderFns } from "./paymentPageDetail.vue?vue&type=template&id=d8b6f85a&"
import script from "./paymentPageDetail.vue?vue&type=script&lang=js&"
export * from "./paymentPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./paymentPageDetail.vue?vue&type=style&index=0&id=d8b6f85a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports